__turbopack_context__.v({
  "body-20": "type-styles-module-scss-module__YGKmvq__body-20",
  "body-20--lg": "type-styles-module-scss-module__YGKmvq__body-20--lg",
  "body-20--md": "type-styles-module-scss-module__YGKmvq__body-20--md",
  "body-20--sm": "type-styles-module-scss-module__YGKmvq__body-20--sm",
  "body-2xl": "type-styles-module-scss-module__YGKmvq__body-2xl",
  "body-2xl--lg": "type-styles-module-scss-module__YGKmvq__body-2xl--lg",
  "body-2xl--md": "type-styles-module-scss-module__YGKmvq__body-2xl--md",
  "body-2xl--sm": "type-styles-module-scss-module__YGKmvq__body-2xl--sm",
  "body-2xs": "type-styles-module-scss-module__YGKmvq__body-2xs",
  "body-2xs--lg": "type-styles-module-scss-module__YGKmvq__body-2xs--lg",
  "body-2xs--md": "type-styles-module-scss-module__YGKmvq__body-2xs--md",
  "body-2xs--sm": "type-styles-module-scss-module__YGKmvq__body-2xs--sm",
  "body-3xl": "type-styles-module-scss-module__YGKmvq__body-3xl",
  "body-3xl--lg": "type-styles-module-scss-module__YGKmvq__body-3xl--lg",
  "body-3xl--md": "type-styles-module-scss-module__YGKmvq__body-3xl--md",
  "body-3xl--sm": "type-styles-module-scss-module__YGKmvq__body-3xl--sm",
  "body-3xs": "type-styles-module-scss-module__YGKmvq__body-3xs",
  "body-3xs--lg": "type-styles-module-scss-module__YGKmvq__body-3xs--lg",
  "body-3xs--md": "type-styles-module-scss-module__YGKmvq__body-3xs--md",
  "body-3xs--sm": "type-styles-module-scss-module__YGKmvq__body-3xs--sm",
  "body-lg": "type-styles-module-scss-module__YGKmvq__body-lg",
  "body-lg--lg": "type-styles-module-scss-module__YGKmvq__body-lg--lg",
  "body-lg--md": "type-styles-module-scss-module__YGKmvq__body-lg--md",
  "body-lg--sm": "type-styles-module-scss-module__YGKmvq__body-lg--sm",
  "body-md": "type-styles-module-scss-module__YGKmvq__body-md",
  "body-md--lg": "type-styles-module-scss-module__YGKmvq__body-md--lg",
  "body-md--md": "type-styles-module-scss-module__YGKmvq__body-md--md",
  "body-md--sm": "type-styles-module-scss-module__YGKmvq__body-md--sm",
  "body-xl": "type-styles-module-scss-module__YGKmvq__body-xl",
  "body-xl--lg": "type-styles-module-scss-module__YGKmvq__body-xl--lg",
  "body-xl--md": "type-styles-module-scss-module__YGKmvq__body-xl--md",
  "body-xl--sm": "type-styles-module-scss-module__YGKmvq__body-xl--sm",
  "body-xs": "type-styles-module-scss-module__YGKmvq__body-xs",
  "body-xs--lg": "type-styles-module-scss-module__YGKmvq__body-xs--lg",
  "body-xs--md": "type-styles-module-scss-module__YGKmvq__body-xs--md",
  "body-xs--sm": "type-styles-module-scss-module__YGKmvq__body-xs--sm",
  "heading-120": "type-styles-module-scss-module__YGKmvq__heading-120",
  "heading-120--lg": "type-styles-module-scss-module__YGKmvq__heading-120--lg",
  "heading-120--md": "type-styles-module-scss-module__YGKmvq__heading-120--md",
  "heading-120--sm": "type-styles-module-scss-module__YGKmvq__heading-120--sm",
  "heading-128": "type-styles-module-scss-module__YGKmvq__heading-128",
  "heading-128--lg": "type-styles-module-scss-module__YGKmvq__heading-128--lg",
  "heading-128--md": "type-styles-module-scss-module__YGKmvq__heading-128--md",
  "heading-128--sm": "type-styles-module-scss-module__YGKmvq__heading-128--sm",
  "heading-150": "type-styles-module-scss-module__YGKmvq__heading-150",
  "heading-150--lg": "type-styles-module-scss-module__YGKmvq__heading-150--lg",
  "heading-150--md": "type-styles-module-scss-module__YGKmvq__heading-150--md",
  "heading-150--sm": "type-styles-module-scss-module__YGKmvq__heading-150--sm",
  "heading-2xl": "type-styles-module-scss-module__YGKmvq__heading-2xl",
  "heading-2xl--lg": "type-styles-module-scss-module__YGKmvq__heading-2xl--lg",
  "heading-2xl--md": "type-styles-module-scss-module__YGKmvq__heading-2xl--md",
  "heading-2xl--sm": "type-styles-module-scss-module__YGKmvq__heading-2xl--sm",
  "heading-3xl": "type-styles-module-scss-module__YGKmvq__heading-3xl",
  "heading-3xl--lg": "type-styles-module-scss-module__YGKmvq__heading-3xl--lg",
  "heading-3xl--md": "type-styles-module-scss-module__YGKmvq__heading-3xl--md",
  "heading-3xl--sm": "type-styles-module-scss-module__YGKmvq__heading-3xl--sm",
  "heading-4xl": "type-styles-module-scss-module__YGKmvq__heading-4xl",
  "heading-4xl--lg": "type-styles-module-scss-module__YGKmvq__heading-4xl--lg",
  "heading-4xl--md": "type-styles-module-scss-module__YGKmvq__heading-4xl--md",
  "heading-4xl--sm": "type-styles-module-scss-module__YGKmvq__heading-4xl--sm",
  "heading-5xl": "type-styles-module-scss-module__YGKmvq__heading-5xl",
  "heading-5xl--lg": "type-styles-module-scss-module__YGKmvq__heading-5xl--lg",
  "heading-5xl--md": "type-styles-module-scss-module__YGKmvq__heading-5xl--md",
  "heading-5xl--sm": "type-styles-module-scss-module__YGKmvq__heading-5xl--sm",
  "heading-60": "type-styles-module-scss-module__YGKmvq__heading-60",
  "heading-60--lg": "type-styles-module-scss-module__YGKmvq__heading-60--lg",
  "heading-60--md": "type-styles-module-scss-module__YGKmvq__heading-60--md",
  "heading-60--sm": "type-styles-module-scss-module__YGKmvq__heading-60--sm",
  "heading-70": "type-styles-module-scss-module__YGKmvq__heading-70",
  "heading-70--lg": "type-styles-module-scss-module__YGKmvq__heading-70--lg",
  "heading-70--md": "type-styles-module-scss-module__YGKmvq__heading-70--md",
  "heading-70--sm": "type-styles-module-scss-module__YGKmvq__heading-70--sm",
  "heading-90": "type-styles-module-scss-module__YGKmvq__heading-90",
  "heading-90--lg": "type-styles-module-scss-module__YGKmvq__heading-90--lg",
  "heading-90--md": "type-styles-module-scss-module__YGKmvq__heading-90--md",
  "heading-90--sm": "type-styles-module-scss-module__YGKmvq__heading-90--sm",
  "heading-lg": "type-styles-module-scss-module__YGKmvq__heading-lg",
  "heading-lg--lg": "type-styles-module-scss-module__YGKmvq__heading-lg--lg",
  "heading-lg--md": "type-styles-module-scss-module__YGKmvq__heading-lg--md",
  "heading-lg--sm": "type-styles-module-scss-module__YGKmvq__heading-lg--sm",
  "heading-md": "type-styles-module-scss-module__YGKmvq__heading-md",
  "heading-md--lg": "type-styles-module-scss-module__YGKmvq__heading-md--lg",
  "heading-md--md": "type-styles-module-scss-module__YGKmvq__heading-md--md",
  "heading-md--sm": "type-styles-module-scss-module__YGKmvq__heading-md--sm",
  "heading-sm": "type-styles-module-scss-module__YGKmvq__heading-sm",
  "heading-sm--lg": "type-styles-module-scss-module__YGKmvq__heading-sm--lg",
  "heading-sm--md": "type-styles-module-scss-module__YGKmvq__heading-sm--md",
  "heading-sm--sm": "type-styles-module-scss-module__YGKmvq__heading-sm--sm",
  "heading-xl": "type-styles-module-scss-module__YGKmvq__heading-xl",
  "heading-xl--lg": "type-styles-module-scss-module__YGKmvq__heading-xl--lg",
  "heading-xl--md": "type-styles-module-scss-module__YGKmvq__heading-xl--md",
  "heading-xl--sm": "type-styles-module-scss-module__YGKmvq__heading-xl--sm",
  "heading-xs": "type-styles-module-scss-module__YGKmvq__heading-xs",
  "heading-xs--lg": "type-styles-module-scss-module__YGKmvq__heading-xs--lg",
  "heading-xs--md": "type-styles-module-scss-module__YGKmvq__heading-xs--md",
  "heading-xs--sm": "type-styles-module-scss-module__YGKmvq__heading-xs--sm",
  "heading-xxs": "type-styles-module-scss-module__YGKmvq__heading-xxs",
  "heading-xxs--lg": "type-styles-module-scss-module__YGKmvq__heading-xxs--lg",
  "heading-xxs--md": "type-styles-module-scss-module__YGKmvq__heading-xxs--md",
  "heading-xxs--sm": "type-styles-module-scss-module__YGKmvq__heading-xxs--sm",
  "large-prompt": "type-styles-module-scss-module__YGKmvq__large-prompt",
  "large-prompt--lg": "type-styles-module-scss-module__YGKmvq__large-prompt--lg",
  "large-prompt--md": "type-styles-module-scss-module__YGKmvq__large-prompt--md",
  "large-prompt--sm": "type-styles-module-scss-module__YGKmvq__large-prompt--sm",
});
